import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateMultipleContentsMutation } from "../graphql/mutations";
import type {
  CreateMultipleContentsMutationType,
  CreateMultipleContentsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateMultipleContentsMutation = (
  options?: MutationHookOptions<
    CreateMultipleContentsMutationType,
    CreateMultipleContentsMutationVariablesType
  >
) => {
  return useMutation<
    CreateMultipleContentsMutationType,
    CreateMultipleContentsMutationVariablesType
  >(CreateMultipleContentsMutation, options);
};
